<template>
  <Modal v-bind="$attrs" hidden-nav @close="handleClose" :width="600">
    <div class="success">
      <div class="title">{{ $t("modalSuccess.title") }}</div>
      <div class="icon">√</div>
      <div class="essay">{{ $t("modalSuccess.essay") }}</div>
      <Button @click="handleClose">{{ $t("modalSuccess.button") }}</Button>
    </div>
  </Modal>
</template>

<script>
import Modal from "../Modal/index.desktop";
import Button from "../Button/button.desktop";
export default {
  name: "ModalSuccess",
  data() {
    return {
      show: false,
    };
  },
  components: { Modal, Button },
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
.success {
  color: #fff;
  text-align: center;
  padding: 14px 80px 0;
  @include phone(
    (
      padding: 14px 24px,
    )
  );
  .title {
    font-size: 24px;
  }

  .icon {
    line-height: 100px;
    width: 100px;
    height: 100px;
    text-align: center;
    font-size: 50px;
    border-radius: 50%;
    background: linear-gradient(135deg, #d3be8c 0%, #c2a061 100%);
    margin: 45px auto 28px auto;
  }
  .essay {
    font-size: 18px;
    margin-bottom: 53px;
  }
  .btn {
    width: 400px;
    margin-bottom: 44px;
    @include phone(
      (
        width: 100%,
      )
    );
  }
}
</style>
